import React from 'react';
import PropTypes from 'prop-types';
import { defineMessages, injectIntl } from 'react-intl';
import RemoveIcon from '@material-ui/icons/Remove';
import AddIcon from '@material-ui/icons/Add';

import './index.sass';

import Button from '../../Atoms/Button';
import Text from '../../Atoms/Text';

const ProductQuantityControls = ({
	className,
	size,
	quantity,
	isLoading,
	onAdd,
	onRemove,
	intl,
}) => {
	const { formatMessage } = intl;
	const messages = defineMessages({
		addToCart: {
			id: 'gallery.otherProducts.addToCart',
			defaultMessage: 'Adicionar ao carrinho',
		},
		removeOne: {
			id: 'gallery.otherProducts.removeOne',
			defaultMessage: 'Remover um',
		},
	});

	const hasQuantity = quantity > 0;
	const handleAdd = (event) => {
		if (event) event.stopPropagation();
		onAdd(event);
	};
	const handleRemove = (event) => {
		if (event) event.stopPropagation();
		onRemove(event);
	};

	return (
		<div
			className={`ProductQuantityControls ProductQuantityControls--${size} ${
				hasQuantity ? 'ProductQuantityControls--hasQuantity' : 'ProductQuantityControls--noQuantity'
			} ${className}`}
		>
			{hasQuantity && (
				<Button
					className="ProductQuantityControls__button ProductQuantityControls__button--remove"
					color="tertiary"
					size={size}
					loading={isLoading}
					disabled={isLoading}
					onClick={handleRemove}
					aria-label={formatMessage(messages.removeOne)}
				>
					<RemoveIcon fontSize="small" />
				</Button>
			)}
			{hasQuantity && (
				<Text className="ProductQuantityControls__quantity" variant="body2">
					{quantity}
				</Text>
			)}
			<Button
				className="ProductQuantityControls__button ProductQuantityControls__button--add"
				color="secondary"
				size={size}
				loading={isLoading}
				disabled={isLoading}
				onClick={handleAdd}
				aria-label={hasQuantity ? formatMessage(messages.addToCart) : undefined}
			>
				{hasQuantity ? <AddIcon fontSize="small" /> : formatMessage(messages.addToCart)}
			</Button>
		</div>
	);
};

ProductQuantityControls.propTypes = {
	className: PropTypes.string,
	size: PropTypes.oneOf(['small', 'medium']),
	quantity: PropTypes.number,
	isLoading: PropTypes.bool,
	onAdd: PropTypes.func.isRequired,
	onRemove: PropTypes.func.isRequired,
	intl: PropTypes.object.isRequired,
};

ProductQuantityControls.defaultProps = {
	className: '',
	size: 'small',
	quantity: 0,
	isLoading: false,
};

export default injectIntl(ProductQuantityControls);
